
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { getUnitLabel } from '@/types/unit-types';
import { formatCurrency } from '@/lib/utils';
import DataTableWrapper from '@/components/shared/DataTableWrapper';

interface InvoiceItemsTableProps {
  lineItems: any[];
  isLoading: boolean;
}

const InvoiceItemsTable: React.FC<InvoiceItemsTableProps> = ({ lineItems, isLoading }) => {
  return (
    <Card className="lg:col-span-2">
      <CardHeader>
        <CardTitle>Invoice Items</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <DataTableWrapper
          isLoading={isLoading}
          isEmpty={!lineItems || lineItems.length === 0}
          emptyState={{
            title: "No invoice items",
            description: "No items found for this invoice."
          }}
        >
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Description</TableHead>
                <TableHead className="hidden sm:table-cell">Unit</TableHead>
                <TableHead className="hidden sm:table-cell">Qty</TableHead>
                <TableHead className="hidden md:table-cell text-right">Unit Cost</TableHead>
                <TableHead className="text-right">Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {lineItems?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="min-w-0">
                    <div className="whitespace-normal break-words">
                      {item.description}
                    </div>
                    {/* Show unit and qty on mobile as subtext */}
                    <div className="text-xs text-muted-foreground sm:hidden">
                      {item.quantity_invoiced} {getUnitLabel(item.base_unit)}
                    </div>
                  </TableCell>
                  <TableCell className="hidden sm:table-cell">{getUnitLabel(item.base_unit)}</TableCell>
                  <TableCell className="hidden sm:table-cell">{item.quantity_invoiced}</TableCell>
                  <TableCell className="hidden md:table-cell text-right whitespace-nowrap font-mono">{formatCurrency(item.unit_cost)}</TableCell>
                  <TableCell className="text-right whitespace-nowrap font-mono">{formatCurrency(item.total_cost)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DataTableWrapper>
      </CardContent>
    </Card>
  );
};

export default InvoiceItemsTable;
